import { render, staticRenderFns } from "./TrainPeriodAdd.vue?vue&type=template&id=102d5e3a&"
import script from "./TrainPeriodAdd.vue?vue&type=script&lang=js&"
export * from "./TrainPeriodAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports